import { z } from 'zod';
import { BaseResponseSchema, } from './primitives.js';
// Upload/File Management Schemas
export const FilenameParamSchema = z.object({
    filename: z.string().min(1)
});
export const PresignedUploadRequestSchema = z.object({
    originalFileName: z.string().min(1).max(255),
    mimeType: z.string().min(1).max(100),
    folder: z.string().max(50).optional(),
    subFolder: z.string().max(50).optional()
});
export const ConfirmUploadRequestSchema = z.object({
    objectKey: z.string().min(1),
    originalName: z.string().min(1),
    mimeType: z.string().min(1),
    size: z.number().int().min(1)
});
export const FileUploadResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        uploadedFiles: z.array(z.object({
            objectKey: z.string(),
            originalName: z.string(),
            mimeType: z.string(),
            size: z.number().int()
        })),
        totalFiles: z.number().int()
    })
});
export const SingleFileUploadResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        objectKey: z.string(),
        originalName: z.string(),
        mimeType: z.string(),
        size: z.number().int()
    })
});
export const PresignedUploadResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        uploadUrl: z.string().url(),
        objectKey: z.string(),
        formData: z.record(z.string())
    })
});
export const ConfirmUploadResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        fileKey: z.string()
    })
});
//# sourceMappingURL=tenant-upload-presigned.schemas.js.map